import React, { Component } from 'react'
import { connect } from "react-redux";
import classnames from "classnames";
import { get } from 'lodash';

import Button from './shared/Button';

import vpn from './../img/vpn@3x.png';
import baseStyles from 'custom/base.styl';
import grid from './../styles/grid.styl';

const MAILTO = 'recruiting.team@liv-research.com'

class PageInfoVpn extends Component {
  constructor(props) {
    super(props)

    this._handleOnClick = this._handleOnClick.bind(this)
  }

  _handleOnClick() {
    document.location.reload(true);
  }

  render() {
    return (
      <div className={classnames(baseStyles.tutorial_content)}>
        <span className={baseStyles.tutorial_line}>
          <i className={baseStyles.tutorial_line_alarm} />
        </span>

        <div className={classnames(baseStyles.content_body, baseStyles.text_light)}>
          <h1 className={classnames(baseStyles.title_extra_large, baseStyles.mb_10)}>Oops, something went wrong</h1>
          <h3 className={classnames(baseStyles.title_small, baseStyles.danger_text, baseStyles.mb_40)}>You are using a VPN service or proxy, aren't you?</h3>
          <p className={classnames(baseStyles.mb_20, baseStyles.title_extra_small, baseStyles.text_light)}>Please turn it off and press the button below to continue.</p>
          <Button className={classnames(baseStyles.mb_80)} onClick={this._handleOnClick}>Done. Let me in</Button>

          <div className={classnames(grid.row, baseStyles.mb_30)}>
            <div className={classnames(grid.col_5)}>
              <p>
                In case your VPN is disabled but you still have access <br /> problems, please, contact our recruiting team: <br />
                <a href={`mailto:${MAILTO}`}>{MAILTO}</a>
              </p>
            </div>
            <div className={classnames(grid.col_3)}>
              <img className={classnames(baseStyles.hide_xs, baseStyles.vpn_img)} src={vpn} alt="vpn" width="286px" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const profile = state.profile;
  const { data } = profile;
  const profileStage = get(data, 'user.stage', {});

  return {
    profile,
    profileStage,
  };
};

export default connect(mapStateToProps, null)(PageInfoVpn);



// WEBPACK FOOTER //
// ./src/components/PageInfoVpn.js